import { SVGProps } from 'react';

const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M11.386 1.21a1 1 0 0 1 1.228 0l9 7A1 1 0 0 1 22 9v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9a1 1 0 0 1 .386-.79l9-7ZM10 21h4v-8h-4v8Zm6 0v-9a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v9H5a1 1 0 0 1-1-1V9.49l8-6.223 8 6.222V20a1 1 0 0 1-1 1h-3Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgHome;
